import { getABTProvider } from '@/plugins/abt/statsig'

export const MERCHANT_EXPORTED_REQUESTS_V2_FLAG =
  'gate_temp_merchant_exported_requests_v2'

export const EXPORTED_LIST_PATH_V1 = '/exports/list'
/** Next.js app basePath is `/v2`, page route is `/exported-list`. */
export const EXPORTED_LIST_PATH_V2 = '/v2/exported-list'

export function isMerchantExportedRequestsV2Enabled() {
  return getABTProvider().isFeatureEnabled(MERCHANT_EXPORTED_REQUESTS_V2_FLAG)
}

export function getExportedListPath() {
  return isMerchantExportedRequestsV2Enabled()
    ? EXPORTED_LIST_PATH_V2
    : EXPORTED_LIST_PATH_V1
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function redirectToExportedListPath(to = {}) {
  const query = to.query || {}
  const queryString =
    Object.keys(query).length > 0
      ? '?' + new URLSearchParams(query).toString()
      : ''

  window.location.replace(
    window.location.origin + EXPORTED_LIST_PATH_V2 + queryString
  )
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function navigateToExportedList(router, { query } = {}) {
  if (isMerchantExportedRequestsV2Enabled()) {
    redirectToExportedListPath({ query })
    return
  }

  router.push({ path: EXPORTED_LIST_PATH_V1, query })
}
